const config = {
  baseAPI: 'https://stg-customer-service-api.kongsalak.dev',
  apiGatewayUrl: 'https://stg-user-api-gateway.kongsalak.dev',
  redirectUrl: 'https://stg-kslplus-frontend-internal.kongsalak.dev:8443',
  liffId: '1660835514-5bJgEXb4',
  cookieDomain: 'localhost',
};

export default config;
